module.exports = __webpack_public_path__ + "img/SS_Facility_Google-Map-Pin_Purple.661cb9c0.png";